module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-1750.359a0d02.svg";